import { cn } from '@src/design-system/helpers';
import { PROGRAM_STATUSES } from '@shared/types/program';
import type { TLead } from '@shared/types/lead';

export function StatusCell({
  program,
}: {
  program: TLead['programs'][number];
}) {
  const status = program.status;
  return (
    <div
      className={cn(
        'rounded-xl min-w-[80px] h-[32px] text-sm p-2 flex justify-center items-center gap-1',
        {
          'text-green-500 bg-green-100': status === PROGRAM_STATUSES.active,
          'text-red-500 bg-red-100': status === PROGRAM_STATUSES.inActive,
          'text-gray-800 bg-gray-100': status === PROGRAM_STATUSES.archived,
          'text-gray-900 bg-primary-100': status === PROGRAM_STATUSES.draft,
        }
      )}
    >
      {status}
    </div>
  );
}
